import MemberDetailsViewModel from './member-details-view-model';

export class MemberDetailsPanelContext {
    public constructor(
        public viewModel: MemberDetailsViewModel,
        public areAllUsersMatched: boolean = true,
    ) { }
}
